import { render } from "./SelectPageMenu.vue?vue&type=template&id=d978c910"
import script from "./SelectPageMenu.vue?vue&type=script&lang=js"
export * from "./SelectPageMenu.vue?vue&type=script&lang=js"

import "./SelectPageMenu.vue?vue&type=style&index=0&id=d978c910&lang=scss"

import exportComponent from "/Users/dservdevel/jenkins_node/workspace/t_ccidist-reader-vue_release_5.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__